import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const NavbarContainer = styled.header`
  width: 100%;
  height: 80px;
  padding: 0 3rem;
  margin-bottom: 0.6rem;
  position: sticky;
  top: 0;
  z-index: 999;
  background: linear-gradient(180deg, var(--violetaOscuro) 0%, #3a0570 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: ${FONT_STACK};
  -webkit-font-smoothing: antialiased;
  box-shadow: 0 2px 12px -2px rgba(0, 0, 0, 0.35);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      var(--naranja) 0%,
      var(--violeta) 50%,
      var(--violetaPastel) 100%
    );
  }

  h2 {
    color: white;
    font-family: ${FONT_STACK};
    font-weight: 700;
    font-size: 1.4rem;
    letter-spacing: -0.02em;
  }

  @media (max-width: 800px) {
    justify-content: center;
    margin: auto;
    height: 150px;
    padding: 1rem 0;
    flex-direction: column;
    gap: 30px;
    width: 100%;
    position: fixed;
    h2 {
      margin-top: 10px;
      height: 40px;
      font-size: 2rem;
    }
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    justify-content: center;
    height: 150px;
    padding: 1rem 0;
    flex-direction: column;
    gap: 30px;
    width: 100%;
    position: fixed;
    h2 {
      font-size: 2.5rem;
    }
  }
`;

export const LinkContainer = styled.ul`
  display: flex;
  align-items: center;
  gap: 28px;
  color: white;
  font-family: ${FONT_STACK};
  font-weight: 500;
  font-size: 0.9rem;
  letter-spacing: -0.005em;

  @media (max-width: 800px) {
    padding: 10px;
    gap: 100px;
  }
`;

export const NavLinkContainer = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 800px) {
    gap: 10px;
  }
`;
